import {cx} from "@emotion/css";
import * as React from "react";

import "./inspect.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {keyed}          from "@Common/react/keyed";
import {Load}           from "@Common/react/load";
import {reverse}        from "@Common/utils/collections";

import {avoidEdges}     from "../common/avoid-edges";
import {getWebstormUrl} from "../common/get-webstorm-url";
import {Path}           from "../common/path";
import {toCssPos}       from "../common/to-css-pos";
import {getTagPath}     from "../get-tag-path";

export const Inspect = ({pos, tag}) => cs(
    consumeContext("apis"),
    ["code", ({apis}, next) => Load({
        fetch: () => apis.getCodeForTag(getTagPath(tag)),
        next,
    })],
    ["winSize", (_, next) => next({width: window.innerWidth, height: window.innerHeight})],
    ({winSize, code}) => (
        <div className={cx("inspect-2le")} style={toCssPos(pos)}>
            <div className={cx("box", avoidEdges(pos, winSize))}>
                {reverse(code)?.map((code1, i) => cs(
                    keyed(i),
                    () => (
                        <div
                            className="line"
                            onClick={(e) => {
                                if (e.metaKey) {
                                    window.open(getWebstormUrl(code1))
                                }
                            }}
                        >
                            {Path.basename(code1.file) + (code1.line ? ":" + code1.line : "")}
                        </div>
                    ),
                ))}
            </div>
        </div>
    ),
);
